import { Box, Container, Typography } from '@mui/material';
import { useAppSelector } from 'redux/hooks';
import { NEW_USER, ONBOARDING } from 'codes';
import { InlineWidget } from "react-calendly";

const CALENDLY_SUPPORT_URL = 'https://calendly.com/avneetbaliyan0/new-meeting';
const CALENDLY_ONBOARDING_URL = 'https://calendly.com/avneetbaliyan0/onboarding-call';

const BookMeeting = () => {
  const appState = useAppSelector((state) => state.appState.value);

  let calendlyUrl = CALENDLY_ONBOARDING_URL;
  if (appState === NEW_USER) {
    calendlyUrl = CALENDLY_SUPPORT_URL;
  } else if (appState === ONBOARDING) {
    calendlyUrl = CALENDLY_ONBOARDING_URL;
  }

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Book a Meeting with Incomlend Team
        </Typography>
        <InlineWidget
          url={calendlyUrl}
          styles={{ minWidth: "320px", height: "700px" }}
        />
      </Box>
    </Container>
  );
};

export default BookMeeting;
